import { __assign } from "tslib";
import React from 'react';
import Popper from './Popper';
import PopperManager from './PopperManager';
import s from './PopperPopover.scss';
/** @deprecated */
var PopperPopover = function (props) {
    return (React.createElement(PopperManager, { renderReference: function (_a) {
            var ref = _a.ref;
            return (React.createElement("span", { className: s['ref-style'], ref: ref }));
        } },
        React.createElement(Popper, __assign({}, props))));
};
PopperPopover.displayName = 'PopperPopover';
export default PopperPopover;
//# sourceMappingURL=PopperPopover.js.map